import styled from 'styled-components'
import { Styles as BaseStyles } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  ...BaseStyles,

  EmojiRatingCard: styled.div`
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GRAY_400};
    border-radius: 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 16px 8px;
  `,

  EmojiButton: styled.button<{ $isSelected: boolean; $fontSize: number }>`
    background: ${({ $isSelected }) =>
      $isSelected ? COLORS.PURPLE_100 : 'transparent'};
    border: 1px solid
      ${({ $isSelected }) => ($isSelected ? COLORS.PURPLE_500 : 'transparent')};
    cursor: pointer;
    font-size: ${({ $fontSize }) => $fontSize}px;
    line-height: 1;
    padding: 4px 8px;
    border-radius: 8px;
    transition: transform 0.15s ease, background 0.15s ease,
      border-color 0.15s ease;
    transform: ${({ $isSelected }) =>
      $isSelected ? 'scale(1.15)' : 'scale(1)'};
    opacity: ${({ $isSelected }) => ($isSelected ? '1' : '0.75')};

    &:active {
      transform: scale(1.05);
    }
  `,
} as const
